module.exports = __webpack_public_path__ + "static/hero_art-77d0407eee124fdccfca27bc549a3c81.png";